import Text from '../Text';
import Game from '../../Game';
import AnimationComponent from '../../Component/Animation';

export default class StreakTextEffect extends Text {
    public onCreate(params: any): void {
        super.onCreate({
            style: Game.style.getStyle('streak.text'),
            ...params,
        });

        this.addComponent(AnimationComponent, {
            playOnStart: true,
            clipName: 'StreakTextPopIn',
            ...params,
        });
    }
}
